import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "@/api/client";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      retry: (failureCount, error) => {
		if (failureCount >= 2) {
		  return false;
		}
		return error instanceof ApiError ? error.status >= 500 : true;
      }
    },
    mutations: {
      retry: false
    }
  }
});
